import { instance } from 'store/utils'; 
import { types } from './types';

// Action to find keywords for admin
export const findKeywordsForAdmin = (searchKey) => dispatch => {
    dispatch({ type: types.FIND_KEYWORDS.START });
    instance.get(`/admin/findSAYT?searchKey=${encodeURIComponent(searchKey)}`)
        .then(response => {
            dispatch({ type: types.FIND_KEYWORDS.SUCCESS, payload: response.data });
        })
        .catch(error => {
            dispatch({ type: types.FIND_KEYWORDS.ERROR, error });
        });
};

// Action to get a list of applications
export const getListOfApplications = (data) => dispatch => {
    //const queryParams = new URLSearchParams(dto).toString();
    dispatch({ type: types.LIST_APPLICATIONS_ADMIN.START });
    instance.post(`/admin/process-instances-apptrack`, data)
      .then(response => {
        const res = response.data.data
        const results = Object.keys(res).map(key => ({
          id: key,
          ...res[key]
        }))
        dispatch({
          type: types.LIST_APPLICATIONS_ADMIN.SUCCESS,
          payload: {
            variables: results
          },
        });
        // if(!params.isViewMode){
        // dispatch(getFormData(params.taskId));
        // }
      })
      .catch(error => {
        console.log(error, 'error');
        dispatch({ type: types.LIST_APPLICATIONS_ADMIN.ERROR });
      });
};

// Action to get application details
export const getApplicationDetails = (procInstId) => dispatch => {
    dispatch({ type: types.APP_DETAILS.START });
    instance.get(`/admin/process-instance-apptrack-detailed/${procInstId}`)
        .then(response => {
            dispatch({ type: types.APP_DETAILS.SUCCESS, payload: response.data });
        })
        .catch(error => {
            dispatch({ type: types.APP_DETAILS.ERROR, error });
        });
};

// Action to cancel a process instance
export const cancelProcessInstance = (procInstId) => dispatch => {
    dispatch({ type: types.CANCEL_PROCESS.START });
    instance.get(`/admin/cancel-process-instance/${procInstId}`)
        .then(response => {
            dispatch({ type: types.CANCEL_PROCESS.SUCCESS, payload: response.data });
        })
        .catch(error => {
            dispatch({ type: types.CANCEL_PROCESS.ERROR, error });
        });
};

// Action to get all active task names
export const getAllActiveTaskNames = () => dispatch => {
    dispatch({ type: types.ACTIVE_TASK_NAMES.START });
    instance.get('/admin/all-active-task-names')
        .then(response => {
            dispatch({ type: types.ACTIVE_TASK_NAMES.SUCCESS, payload: response.data });
        })
        .catch(error => {
            dispatch({ type: types.ACTIVE_TASK_NAMES.ERROR, error });
        });
};

export const getActions = procInstId => dispatch => {
    dispatch({ type: types.GET_ACTIONS_ADMIN.START });
    instance
    .get(`/admin/${procInstId}/actions`)
      .then(response => {
        dispatch({ type: types.GET_ACTIONS_ADMIN.SUCCESS, payload: response.data });
      })
      .catch(error => {
        console.log(error, 'error');
        dispatch({ type: types.GET_ACTIONS_ADMIN.ERROR });
      });
  };


  export const getProcessVariables = procInstId => dispatch => {
    dispatch({ type: types.GET_PROCESS_VARIABLES_ADMIN.START });
    instance
    .get(`/admin/process-instance-variables?processInstanceId=${procInstId}`)
      .then(response => {
        dispatch({ type: types.GET_PROCESS_VARIABLES_ADMIN.SUCCESS, payload: response.data });
      })
      .catch(error => {
        console.log(error, 'error');
        dispatch({ type: types.GET_PROCESS_VARIABLES_ADMIN.ERROR });
      });
  };

  export const updateAdminField = payload => dispatch => {
    dispatch({ type: types.UPDATE_ADMIN_FIELD, payload });
  };

  export const updateAdminTableField = payload => dispatch => {
    dispatch({ type: types.UPDATE_ADMIN_TABLE_FIELD, payload });
  };


  export const updateApplication = (variables, procInstId) => dispatch => {
    dispatch({ type: types.UPDATE_PROCESS_ADMIN.START });
    const payload = {
      "variables": [
        variables
      ]
    }
    // dispatch(triggerLoading(true));
    instance.post(`/admin/process-instance-variables?processInstanceId=${procInstId}`, payload)
      .then(() => {

        dispatch({
          type: types.UPDATE_PROCESS_ADMIN.SUCCESS});
        // dispatch(triggerLoading(false));
      })
      .catch(error => {
        console.log(error, 'error');
        dispatch({ type: types.UPDATE_PROCESS_ADMIN.ERROR });
      });
};

export const updateLangConfig = ({payload, callback}) => dispatch => {
 //no endpoint yet from backend
  dispatch({ type: types.UPDATE_APP_CONFIG.START });

};

export const updateAppConfig = (code, value, type) => dispatch => {
  const payload = {
    "code": code,
    "value": value,
    "type": type,
  }
  instance
  .put(`/admin/configuration/${code}`, payload)
    .catch(error => {
      console.log(error, 'error');
    });
};

export const restoreConfig = (code) => {
  instance
  .put(`/admin/configuration/reset/${code}`)
    .catch(error => {
      console.log(error, 'error');
    });
}

export const getAllAppConfigurations = () => dispatch => {
  dispatch({ type: types.GET_ALL_APP_CONFIGURATIONS_ADMIN.START });
  instance
  .get(`/admin/configuration`)
    .then(response => {
      dispatch({ type: types.GET_ALL_APP_CONFIGURATIONS_ADMIN.SUCCESS, payload: response.data });
    })
    .catch(error => {
      console.log(error, 'error');
      dispatch({ type: types.GET_ALL_APP_CONFIGURATIONS_ADMIN.ERROR });
    });
};

export const getSelectedAppConfiguration = (code) => dispatch => {
  dispatch({ type: types.GET_SELECTED_APP_CONFIGURATION_ADMIN.START });
  instance
  .get(`/admin/configuration/${code}`)
    .then(response => {
      dispatch({ type: types.GET_SELECTED_APP_CONFIGURATION_ADMIN.SUCCESS, payload: response.data });
    })
    .catch(error => {
      console.log(error, 'error');
      dispatch({ type: types.GET_SELECTED_APP_CONFIGURATION_ADMIN.ERROR });
    });
};

export const getCountryLocals = (countryCode) => dispatch => {
  dispatch({ type: types.GET_COUNTRY_LOCALS_ADMIN.START });
  instance
  .get(`/localStrings/${countryCode}`)
    .then(response => {
      dispatch({ type: types.GET_COUNTRY_LOCALS_ADMIN.SUCCESS, payload: response.data });
    })
    .catch(error => {
      console.log(error, 'error');
      dispatch({ type: types.GET_COUNTRY_LOCALS_ADMIN.ERROR });
    });
};

export const updateLocal = (countryCode, name, localString) => dispatch => {
  dispatch({ type: types.UPDATE_LOCAL_ADMIN.START });
  const payload = localString;

  instance
    .put(`/admin/localStrings/${countryCode}/${name}`, payload, {
      headers: {
        'Content-Type': 'text/plain'
      }
    })
    .then(response => {
      dispatch({ type: types.UPDATE_LOCAL_ADMIN.SUCCESS, payload: response.data });
    })
    .catch(error => {
      console.log(error, 'error');
      dispatch({ type: types.UPDATE_LOCAL_ADMIN.ERROR });
    });
};

export const restoreLocals = () => {
  console.log("ENTERED");

  return instance
    .put(`/admin/localStrings/restore`)
    .then(response => {
      console.log("response:", response);
      return response;
    })
    .catch(error => {
      console.log(error, 'error');
      throw error;
    });
};

export const getAllUsersData = () => dispatch => {
  dispatch({ type: types.GET_ALL_USERS_DATA_ADMIN.START });
  instance
  .get(`/admin/users`)
    .then(response => {
      dispatch({ type: types.GET_ALL_USERS_DATA_ADMIN.SUCCESS, payload: response.data });
    })
    .catch(error => {
      console.log(error, 'error');
      dispatch({ type: types.GET_ALL_USERS_DATA_ADMIN.ERROR });
    });
};

export const getSelectedUsersData = (id) => (dispatch) => {
  dispatch({ type: types.GET_ALL_USERS_DATA_ADMIN.START });
  return instance
    .get(`/admin/users/${id}`)
    .then(response => {
      return response.data;
    })
    .catch(error => {
      console.log(error, 'error');
      return {};
    });
};


export const getAllGroups = () => dispatch => {
  dispatch({ type: types.GET_ALL_GROUPS_ADMIN.START });
  instance
  .get(`/admin/groups`)
    .then(response => {
      dispatch({ type: types.GET_ALL_GROUPS_ADMIN.SUCCESS, payload: response.data });
    })
    .catch(error => {
      console.log(error, 'error');
      dispatch({ type: types.GET_ALL_GROUPS_ADMIN.ERROR });
    });
}

export const getGroups = () => {
  return instance 
    .get(`/admin/groups`)
    .then(response => {
      // console.log("response:",response);
      return response.data;
    })
}

export const getPrivileges = () => {
  return instance 
    .get(`/admin/privileges`)
    .then(response => {
      // console.log("response:",response);
      return response.data;
    })
}

export const getUserData = (usersId) => dispatch => {
  dispatch({ type: types.GET_USER_DATA_ADMIN.START });
  instance
  .get(`/admin/users/detailedInfo/${usersId}`)
    .then(response => {
      dispatch({ type: types.GET_USER_DATA_ADMIN.SUCCESS, payload: response.data });
    })
    .catch(error => {
      console.log(error, 'error');
      dispatch({ type: types.GET_USER_DATA_ADMIN.ERROR });
    });
};

export const getGroupData = (groupId) => dispatch => {
  dispatch({ type: types.GET_GROUP_DATA_ADMIN.START });
  instance
  .get(`/admin/groups/${groupId}`)
    .then(response => {
      dispatch({ type: types.GET_GROUP_DATA_ADMIN.SUCCESS, payload: response.data });
    })
    .catch(error => {
      console.log(error, 'error');
      dispatch({ type: types.GET_GROUP_DATA_ADMIN.ERROR });
    });
};

export const getGroupById = (groupId, callback) => {
  instance
  .get(`admin/groups/${groupId}`)
    .then(response => {
      callback(response.data);
    })
    .catch(error => {
      console.log(error,"error");
    })
}

export const getPrivilegesByGroup = (groupId, callback) => {
  // console.log("groupid:",groupId);
  const payload = {
    "groupId": groupId
  }
  instance
  // .get(`admin/privileges/${groupId}`)
  .get(`/admin/privileges/of_group?groupId=${groupId}`, payload)
    .then(response => {
      callback(response.data);
    })
    .catch(error => {
      console.log(error,"error");
    })
}

export const createUser = (password, id, firstName, lastName, fullName, email, groups, privileges) => dispatch => {
  dispatch({ type: types.CREATE_USER_ADMIN.START });
  // console.log("GROUPS:",groups);
  const payload = {
    "password": password,
    "id": id,
    "firstName": firstName,
    "lastName": lastName,
    "email": email,
    "fullName": fullName,
    "tenantId": null,
    "groups": [],
    "privileges": [],
  }
  instance.post(`/admin/users`, payload)
    .then(response => {
      dispatch({ type: types.CREATE_USER_ADMIN.SUCCESS, payload: response.data });
      groups.forEach(item => {
        instance.post(`/admin/groups/${item}/members/${id}`)
          .catch(er => {
            console.log(er, 'error');
          });
      });
    })
    .catch(error => {
      console.log(error, 'error');
      dispatch({ type: types.CREATE_USER_ADMIN.ERROR });
    });
}

export const createGroup = (groupId, groupName, groupType) => dispatch => {
  dispatch({ type: types.CREATE_GROUP_ADMIN.START });
  // console.log("GROUPS:",groups);
  const payload = {
    "id": groupId,
    "name": groupName,
    "type": groupType,
  }
  instance.post(`/admin/groups`, payload)
    .then(response => {
      dispatch({ type: types.CREATE_GROUP_ADMIN.SUCCESS, payload: response.data });
    })
    .catch(error => {
      console.log(error, 'error');
      dispatch({ type: types.CREATE_GROUP_ADMIN.ERROR });
    });
}

export const clearUserGroups = (id, groups) => dispatch => {
  return new Promise((resolve, reject) => {
    const promises = groups.map(item => 
      instance.delete(`/admin/groups/${item}/members/${id}`)
    );

    Promise.all(promises)
      .then(responses => {
        resolve(responses);
      })
      .catch(error => {
        console.error(error, 'error');
        reject(error);
      });
  });
};

export const clearGroupsPrivileges = (id, privileges) => {
  return new Promise((resolve, reject) => {
    const promises = privileges.map(item => 
      instance.delete(`/admin/privileges/${item}/groups/${id}`)
    );

    Promise.all(promises)
      .then(responses => {
        resolve(responses);
      })
      .catch(error => {
        console.error(error, 'error');
        reject(error);
      });
  });
};

export const updateUserGroup = (id, groups) => dispatch => {
  dispatch({ type: types.UPDATE_USER_GROUP_ADMIN.START });

  const promises = groups.map(item =>
    instance.post(`/admin/groups/${item}/members/${id}`)
  );

  return Promise.all(promises)
    .then(responses => {
      dispatch({ type: types.UPDATE_USER_GROUP_ADMIN.SUCCESS, payload: groups });
      return responses;
    })
    .catch(error => {
      console.error(error, 'error');
      dispatch({ type: types.UPDATE_USER_GROUP_ADMIN.ERROR });
      throw error;
    });
};

//to be fixed
export const updateGroupPrivileges = (id, privileges, callback) => {
  // dispatch({ type: types.UPDATE_USER_GROUP_ADMIN.START });
  const payload = {
    "groupId": id
  }
  const promises = privileges.map(item =>
    instance.post(`/admin/privileges/${item}/groups`, payload)
  );

  return Promise.all(promises)
    .then(responses => {
      // dispatch({ type: types.UPDATE_USER_GROUP_ADMIN.SUCCESS, payload: groups });
      callback(true);
      return responses;
    })
    .catch(error => {
      console.error(error, 'error');
      // dispatch({ type: types.UPDATE_USER_GROUP_ADMIN.ERROR });
      throw error;
    });
};

export const updateUser = (id, email, firstName, lastName, info) => dispatch => {
  console.log("info",info);
  dispatch({ type: types.UPDATE_USER_ADMIN.START });

  const reduxPayload = {
    "id": id,
    "firstName": firstName,
    "lastName": lastName,
    "email": email,
    "info": info,
  }
  const payload = {
    "id": id,
    "firstName": firstName,
    "lastName": lastName,
    "email": email,
    "tenantId": null,
    "password": "",
    "users": [],
    "info": info,
  }
  instance
  .put(`/admin/users/updateUserDetails`, payload)
    .then(response => {
      dispatch({ type: types.UPDATE_USER_ADMIN.SUCCESS, payload: reduxPayload });
    })
    .catch(error => {
      console.log(error, 'error');
      dispatch({ type: types.UPDATE_USER_ADMIN.ERROR });
    });
}

export const deleteUser = (id) => dispatch => {
  dispatch({ type: types.DELETE_USER_ADMIN.START });
  instance
  .delete(`/admin/users/${id}`)
    .then(response => {
      dispatch({ type: types.DELETE_USER_ADMIN.SUCCESS, payload: id });
    })
    .catch(error => {
      console.log(error, 'error');
      dispatch({ type: types.DELETE_USER_ADMIN.ERROR });
    });

}

export const deleteGroup = (id) => dispatch => {
  dispatch({ type: types.DELETE_GROUP_ADMIN.START });
  instance
  .delete(`/admin/groups/${id}`)
    .then(response => {
      dispatch({ type: types.DELETE_GROUP_ADMIN.SUCCESS, payload: id });
    })
    .catch(error => {
      console.log(error, 'error');
      dispatch({ type: types.DELETE_GROUP_ADMIN.ERROR });
    });

}

export const addKeyValuePair = (id, infoKey, infoDetail) => dispatch => {
  return new Promise ((resolve, reject) => {
    dispatch({ type: types.ADD_USER_INFO_ADMIN.START });

    instance
    .put(`/admin/users/${id}/info?infoKey=${infoKey}&infoDetail=${infoDetail}`)
      .then(response => {
        dispatch({ type: types.ADD_USER_INFO_ADMIN.SUCCESS});
        resolve(response);
      })
      .catch(error => {
        console.log(error, 'error');
        dispatch({ type: types.ADD_USER_INFO_ADMIN.ERROR });
        reject(error);
      });
  });
}


// export default {
//     findKeywordsForAdmin,
//     getListOfApplications,
//     getApplicationDetails,
//     cancelProcessInstance,
//     getAllActiveTaskNames,
//     getActions,
//     updateAdminField
// };
